import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CentralTypeDto from '../central/dto/CentralTypeDto'
import { removeNullKeys } from '../../../utils/StoreUtils'
import Input from '../../../components/forms/Input'
import i18n from 'simple-react-i18n'
import ContributorDto from '../../../referencial/components/contributor/dto/ContributorDto'
import Select from '../../../components/forms/Select'
import PowerSupplyTypeDto from '../powerSupply/dto/PowerSupplyTypeDto'
import TelecomTypeDto from '../telecom/dto/TelecomTypeDto'
import DtoSandreCode from '../../../referencial/dto/DtoSandreCode'
import {
    MAT_CENTRAL,
    MAT_DIVERS,
    MAT_EQUIPMENT,
    MAT_POWER_SUPPLY,
    MAT_SENSOR,
    MAT_SIM,
    MAT_SUBSCRIPTION,
    MAT_TELECOM,
} from '../../constants/MaterielConstants'
import ActionComponent from '../../../components/ActionComponent'
import CentralAction from '../central/actions/CentralAction'
import PowerSupplyAction from '../powerSupply/actions/PowerSupplyAction'
import SensorAction from '../sensor/actions/SensorAction'
import TelecomAction from '../telecom/actions/TelecomAction'
import SimAction from '../sim/actions/SimAction'
import VariousMaterielAction from '../variousMateriel/actions/VariousMaterielAction'
import DtoSensorType from '../sensor/dto/DtoSensorType'
import DtoSimType from '../sim/dto/DtoSimType'
import DtoVariousMaterielType from '../variousMateriel/dto/DtoVariousMaterielType'
import EquipmentAction from '../equipment/actions/EquipmentAction'
import EquipmentTypeDto from '../equipment/dto/EquipmentTypeDto'
import MaterielTypeDto from '../../dto/MaterielTypeDto'
import CentralTypePanel from '../central/components/CentralTypePanel'
import PowerSupplyTypePanel from '../powerSupply/components/PowerSupplyTypePanel'
import SensorTypePanel from '../sensor/components/SensorTypePanel'
import TelecomTypePanel from '../telecom/components/TelecomTypePanel'
import EquipmentTypePanel from '../equipment/components/EquipmentTypePanel'
import { Card, CardContent, Chip, Dialog, DialogContent, Grid2, Icon, Stack } from '@mui/material'
import { getMaterielIconValue } from '../../../utils/MaterielUtils'
import NumberField from '../../../components/forms/NumberField'
import { isEqual, orderBy, uniqBy } from 'lodash'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import ReferencialSandreCodeDto from 'referencial/dto/ReferencialSandreCodeDto'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue, secondaryBlue } from 'utils/constants/ColorTheme'
import { DefaultDialogTitle } from 'components/styled/Dialog'

class MaterielTypeForm extends ActionComponent {
    constructor(props) {
        super(props)
        this.state = {
            materielType: props.materielType,
            isNew: false,
        }
    }

    componentDidUpdate = prevProps => {
        if (!isEqual(prevProps.materielType, this.props.materielType)) {
            this.setState({ materielType: this.props.materielType, isNew: false })
        }
    }

    onChangeType = changes => {
        const newMat = removeNullKeys({ ...this.state.materielType, ...changes })
        this.setState({ materielType: newMat })
        this.props.onChange(newMat)
    }

    getMaterielForm = (matType) => {
        const { contributors, referencialSandreCodes, sandreCodes } = this.props
        switch (matType.materielCategory) {
            case MAT_CENTRAL:
                return (
                    <CentralTypePanel
                        materielType={matType}
                        onChange={this.onChangeType}
                    />
                )
            case MAT_POWER_SUPPLY:
                return (
                    <PowerSupplyTypePanel
                        materielType={matType}
                        onChange={this.onChangeType}
                    />
                )
            case MAT_SENSOR:
                return (
                    <SensorTypePanel
                        materielType={matType}
                        onChange={this.onChangeType}
                    />
                )
            case MAT_TELECOM:
                return (
                    <TelecomTypePanel
                        materielType={matType}
                        onChange={this.onChangeType}
                    />
                )
            case MAT_EQUIPMENT:
                return (
                    <EquipmentTypePanel
                        materielType={matType}
                        onChange={this.onChangeType}
                        openPopin={() => this.setState({ isOpen: true })}
                    />
                )
            case MAT_DIVERS:
                return (
                    <Grid2 container spacing={1}>
                        <Grid2 size={6}>
                            <Select
                                options={contributors}
                                label={i18n.provider}
                                value={matType.provider}
                                onChange={v => this.onChangeType({ provider: v })}
                                keyValue='id'
                                keyLabel='mnemonique'
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Select
                                options={contributors}
                                label={i18n.manufacturer}
                                value={matType.manufacturerId}
                                onChange={v => this.onChangeType({ manufacturerId: v })}
                                keyValue='id'
                                keyLabel='mnemonique'
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Select
                                label={i18n.sandreNomenclature}
                                value={matType.refSandre}
                                options={orderBy(uniqBy(referencialSandreCodes.filter(rsf => rsf.code), 'field'), 'field')}
                                onChange={v => this.onChangeType({ refSandre: v })}
                                nullLabel='&nbsp;'
                                keyValue='field'
                                keyLabel='labelWithCode'
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Select
                                options={matType.refSandre ? orderBy(sandreCodes.filter(sandreCode => sandreCode.field === matType.refSandre), 'reference') : []}
                                label={i18n.sandreCode}
                                value={matType.sandreCode}
                                onChange={v => this.onChangeType({ sandreCode: v })}
                                keyValue='code'
                                keyLabel='labelWithReference'
                                noSort
                            />
                        </Grid2>
                    </Grid2>
                )
            default:
                return (
                    <Grid2 container spacing={1}>
                        <Grid2 size={6}>
                            <Select
                                options={contributors}
                                label={i18n.provider}
                                value={matType.provider}
                                onChange={v => this.onChangeType({ provider: v })}
                                keyValue='id'
                                keyLabel='mnemonique'
                            />
                        </Grid2>
                        <Grid2 size={6}>
                            <Select
                                options={contributors}
                                label={i18n.manufacturer}
                                value={matType.manufacturerId}
                                onChange={v => this.onChangeType({ manufacturerId: v })}
                                keyValue='id'
                                keyLabel='mnemonique'
                            />
                        </Grid2>
                    </Grid2>
                )
        }
    }

    render() {
        const { materielType, isOpen } = this.state
        if (materielType) {
            const {
                materielTypes,
            } = this.props
            const matType = ['central', 'powerSupply', 'sensor', 'sim', 'telecom', 'variousMateriel']
            return (
                <Card>
                    <CardTitle
                        color={darkBlue}
                        title={(
                            <Stack spacing={1} alignItems='center' direction='row'>
                                <Icon fontSize='large'>{getMaterielIconValue(materielType.materielCategory)}</Icon>
                                <span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{materielType.materielLabel}</span>
                            </Stack>
                        )}
                    />
                    <CardContent>
                        <Grid2 container spacing={1}>
                            <Grid2 size={8}>
                                <Input
                                    title={i18n.type}
                                    value={materielType.name}
                                    onChange={v => this.onChangeType({ name: v })}
                                />
                            </Grid2>
                            <Grid2 size={4}>
                                <SimpleDatePicker
                                    label={i18n.startDate}
                                    value={materielType.startDate}
                                    id='matTypeStartDate'
                                    onChange={v => this.onChangeType({ startDate: v })}
                                    max={materielType.endDate}
                                />
                            </Grid2>
                            <Grid2 size={8}>
                                {materielType.materielCategory !== MAT_SUBSCRIPTION && (
                                    <Input
                                        title={i18n.comment}
                                        value={materielType.comment}
                                        onChange={v => this.onChangeType({ comment: v })}
                                    />
                                )}
                            </Grid2>
                            <Grid2 size={4}>
                                <SimpleDatePicker
                                    label={i18n.endDate}
                                    value={materielType.endDate}
                                    id='matTypeEndDate'
                                    onChange={v => this.onChangeType({ endDate: v })}
                                    min={materielType.startDate}
                                />
                            </Grid2>
                            {![MAT_SIM, MAT_SUBSCRIPTION].includes(materielType.materielCategory) && (
                                <Grid2 size={4}>
                                    <NumberField
                                        title={i18n.warranty}
                                        value={materielType.warrantyTime}
                                        onChange={v => this.onChangeType({ warrantyTime: v })}
                                    />
                                </Grid2>
                            )}
                        </Grid2>
                        {materielType.materielCategory !== MAT_SUBSCRIPTION && (
                            <Card>
                                <CardTitle color={darkBlue} title={i18n.defaultValue} />
                                <CardContent>
                                    {this.getMaterielForm(materielType)}
                                </CardContent>
                            </Card>
                        )}
                        <Dialog
                            onClose={() => this.setState({ isOpen: false })}
                            fullWidth
                            maxWidth='md'
                            open={isOpen}
                        >
                            <DefaultDialogTitle title={i18n.pleaseChooseMaterielType} onClose={() => this.setState({ isOpen: false })} />
                            <DialogContent>
                                <Stack sx={{ width: '80%', margin: 'auto' }} spacing={3}>
                                    {matType.map(mat => !!materielTypes.find(({ link }) => link === mat) && (
                                        <Chip
                                            key={mat}
                                            label={i18n[mat]}
                                            component='div'
                                            variant='contained'
                                            sx={{ backgroundColor: secondaryBlue, color: 'white', fontSize: '22px' }}
                                            clickable
                                            onClick={() => this.setState({
                                                materielType: {
                                                    ...materielType,
                                                    [`${mat}Type`]: [
                                                        ...materielType[`${mat}Type`],
                                                        undefined,
                                                    ],
                                                },
                                                isOpen: false,
                                            })}
                                            icon={<Icon color='white'>{getMaterielIconValue(mat)}</Icon>}
                                        />
                                    ))}
                                </Stack>
                            </DialogContent>
                        </Dialog>
                    </CardContent>
                </Card>
            )
        }
        return null
    }
}

MaterielTypeForm.propTypes = {
    materielType: PropTypes.oneOfType([
        PropTypes.instanceOf(CentralTypeDto),
        PropTypes.instanceOf(DtoSensorType),
        PropTypes.instanceOf(PowerSupplyTypeDto),
        PropTypes.instanceOf(TelecomTypeDto),
        PropTypes.instanceOf(DtoSimType),
        PropTypes.instanceOf(DtoVariousMaterielType),
        PropTypes.instanceOf(EquipmentTypeDto),
    ]),
    materielTypes: PropTypes.arrayOf(PropTypes.instanceOf(MaterielTypeDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    sandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(DtoSandreCode)),
    referencialSandreCodes: PropTypes.arrayOf(PropTypes.instanceOf(ReferencialSandreCodeDto)),
    deleteCentralType: PropTypes.func,
    deletePowerSupplyType: PropTypes.func,
    deleteSensorType: PropTypes.func,
    deleteTelecomType: PropTypes.func,
    deleteSimType: PropTypes.func,
    deleteVariousMaterielType: PropTypes.func,
    deleteEquipmentType: PropTypes.func,
    addCentralTypes: PropTypes.func,
    updateCentralTypes: PropTypes.func,
    addPowerSupplyTypes: PropTypes.func,
    updatePowerSupplyTypes: PropTypes.func,
    addSensorTypes: PropTypes.func,
    updateSensorTypes: PropTypes.func,
    addTelecomTypes: PropTypes.func,
    updateTelecomTypes: PropTypes.func,
    addSimTypes: PropTypes.func,
    updateSimTypes: PropTypes.func,
    addVariousMaterielTypes: PropTypes.func,
    updateVariousMaterielTypes: PropTypes.func,
    addEquipmentTypes: PropTypes.func,
    updateEquipmentTypes: PropTypes.func,
}

const mapStateToProps = store => ({
    materielTypes: store.MaterielReducer.materielTypes,
    contributors: store.ContributorReducer.contributors,
    sandreCodes: store.ReferencialReducer.sandreCodes,
    referencialSandreCodes: store.ReferencialReducer.referencialSandreCodes,
})

const mapDispatchToProps = {
    deleteCentralType: CentralAction.deleteCentralType,
    deletePowerSupplyType: PowerSupplyAction.deletePowerSupplyType,
    deleteSensorType: SensorAction.deleteSensorType,
    deleteTelecomType: TelecomAction.deleteTelecomType,
    deleteSimType: SimAction.deleteSimType,
    deleteVariousMaterielType: VariousMaterielAction.deleteVariousMaterielType,
    deleteEquipmentType: EquipmentAction.deleteEquipmentType,
    addCentralTypes: CentralAction.addCentralTypes,
    updateCentralTypes: CentralAction.updateCentralTypes,
    addPowerSupplyTypes: PowerSupplyAction.addPowerSupplyTypes,
    updatePowerSupplyTypes: PowerSupplyAction.updatePowerSupplyTypes,
    addSensorTypes: SensorAction.addSensorTypes,
    updateSensorTypes: SensorAction.updateSensorTypes,
    addTelecomTypes: TelecomAction.addTelecomTypes,
    updateTelecomTypes: TelecomAction.updateTelecomTypes,
    addSimTypes: SimAction.addSimTypes,
    updateSimTypes: SimAction.updateSimTypes,
    addVariousMaterielTypes: VariousMaterielAction.addVariousMaterielTypes,
    updateVariousMaterielTypes: VariousMaterielAction.updateVariousMaterielTypes,
    addEquipmentTypes: EquipmentAction.addEquipmentTypes,
    updateEquipmentTypes: EquipmentAction.updateEquipmentTypes,
}

export default connect(mapStateToProps, mapDispatchToProps)(MaterielTypeForm)